export const agent = {
  yqmh: "ブラインドボックス招待",
  yqzmh: "ブラインドボックスを獲得するための招待",
  bfbkj: "100% 賞品抽選",
  yqpy: "友達を招待",
  pywczcrw: "友達が登録してタスクを完了する",
  hdcmhcs: "ブラインドボックスの抽選回数を取得する",
  jllb: "報酬リスト",
  mhjlbk: "ブラインド ボックスの報酬には次のものが含まれます: {text} 具体的な金額は実際に受け取った報酬によって異なります!",
  kkcs: "{value} 回開くことができます",
  mhmx: "ブラインドボックスの詳細",
  jpmx: "賞品詳細",
  hdmhs: "取得したブラインドボックスの数",
  hyjd: "友達の進歩",
  jplx: "賞品の種類",
  dbmc: "トークン名",
  ypf: "分散",
  wpf: "発送されていません",
  lq: "受信",
  zblw: "周囲の贈り物",
  gxczmh: "{amount} 獲得おめでとうございます。新しい友達を招待し,タスクを完了してブラインド ボックスを獲得しましょう",
  lxkflq: "周辺機器ギフト特典についてはカスタマーサービスにお問い合わせください",
  shdz: "配送先住所",
  rwmc: "タスク名",
  wczt: "完了ステータス",
  hdmhsl: "ブラインドボックスの数を取得する",
  zblqdz: "近くのピックアップ住所",
  shr: "荷受人",
  dh: "電話",
  xxdz: "詳細な住所",
  yqmhhdgz: "招待ブラインドボックスアクティビティルール",
  yqyl: "1.Biking 招待ギフトとは何ですか？",
  yhhkxt: "Biking 招待ギフトは、Biking ユーザーフィードバックシステムで、バイキングを認識し、友人をBiking に招待するすべての忠実なユーザーに恩返しすることを目的としています。",
  yqhyhdfhjl: "Biking 招待ギフトはシンプルで使いやすいです。ユーザーは友達を招待するだけで、豪華な報酬を獲得できます。",
  cyhdhqjl: "次に、イベントに参加してタスクを完了すると、どのような報酬が得られますか？",
  hywcrwhdjl: "招待者は友人を招待し、友人は対応するタスクを完了します。招待者と招待された人の両方がブラインドボックスを入手し、それを開けて報酬を獲得できます。",
  mhhdgz: "3. ブラインドボックスの入手ルール",
  syrwczc: "1. 招待された人が登録と実名認証を完了します - 招待された人はアカウントを有効化するチャンスを1回得ます",
  syrcz: "2. 招待者が100 USDT以上を入金 - 招待者と招待者はそれぞれ1回ずつアカウントを開設できます",
  syrcssxf: "3. 招待者の契約手数料は30USDT以上です - 招待者と招待者はそれぞれ2回の開設機会を得ます",
  qqjyl: "4. オプション取引量 ≥ 200 USDT - 招待者と招待された人はそれぞれ2回の取引開始機会を得ます",
  yxjyl: "5. Gamefiの取引量が200 USDT以上かつ注文オッズが1.2倍以上、オッズが1.2倍未満の注文はカウントされません。招待者と招待された人はそれぞれ2回のオープニング機会を得ます",
  xhmrjyl: "6. スポット購入取引量 ≥ 500 USTD - 招待者と招待された人はそれぞれ1回の開始機会を得ます",
  rwqbwc: " 毎回すべての招待タスクが完了した場合、招待者はブラインド ボックスを開ける機会を最大 8 回得ることができ、すべての招待対象者が完了した場合には、ブラインド ボックスを開ける機会を最大 9 回得ることができます。複数人を招待すると、ルールに従ってブラインド ボックスを獲得するチャンスが累積的に増加します。",
  qtsm: "4. その他の指示",
  mhffsj: "1. ブラインドボックスの配布時間 - 10分ごとに更新",
  jlffsj: "2. 報酬配布時間 - バックエンドは1日1回正午に報酬を配布します",
  syyhjkcj: "3. すべてのユーザーが参加でき、他の活動と競合しません",
  mhcjs: "4. ブラインドボックスの抽選回数は毎月1日にリセットされます。",
  yqmts: "ユーザーを部下として招待するだけで、部下による取引で手数料が発生します",
  fym: "リベートコード",
  fymts: "自分のユーザーより高くない下位ユーザー向けのリベート比率を招待して直接設定し、下位の取引には比例した手数料が割り当てられます",
  szfym: "リベートコードを設定する",
  xzfym: "新しいリベートコードを追加",
  lj: "リンク",
  fybl: "リベート比率",
  yyqhys: "招待した友達の数",
  sykcjs: "残りは作成できます",
  tjlx: "推奨タイプ",
  bwjs: "5. 個人またはチームがブラインドボックス特典を利用していることが判明した場合、CoinKingはアカウント特典の資格を減額または取り消す権利を留保します。この特典に参加したすべてのユーザーは、特典の公式規約に同意したものとみなされ、CoinKing Exchangeは最終的な解釈権を留保します。",
  swmr: "デフォルトとして設定",
  cffym: "リベートコードが重複しています。正しいリベートコードを入力してください。",
  qxtjfym: "まずリベートコードを追加してください",
  xywdbl: "10 <= 私のリベート比率",
  qsrdybl: "対応する比率を入力してください",
  qsrzqsl: "正しい値を入力してください",
  qsrbz: "コメントを入力してください",
  bnbhzf: "特殊文字や絵文字を含めることはできません",
  pfjj: "配布が拒否されました",
  pfsb: "報酬の配布に失敗しました",
  lxkf: "詳細はカスタマーサービスまでお問い合わせください",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/agent/ja_JP.js